var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          attrs: {
            size: "mini",
            disabled: _vm.readonly || _vm.disabled,
            icon: "el-icon-plus",
            type: "primary",
            round: "",
          },
          on: { click: _vm.selectOrg },
        },
        [_vm._v(_vm._s(_vm.placeholder))]
      ),
      _vm._v(" "),
      _c("org-items", {
        attrs: { value: _vm.value, closable: !_vm.disabled },
        on: {
          remove: function ($event) {
            return _vm.$emit("input", _vm.value)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "org-picker",
        _vm._b(
          {
            ref: "orgPicker",
            attrs: {
              title: "请选择",
              selected: _vm.value,
              type: "user",
              multiple: _vm.multiple,
            },
            on: { ok: _vm.selected },
          },
          "org-picker",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }